/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".theme-light[_nghost-%COMP%]   .counter__label[_ngcontent-%COMP%], .theme-light   [_nghost-%COMP%]   .counter__label[_ngcontent-%COMP%]{color:#1c2a3f}.theme-dark[_nghost-%COMP%]   .counter__label[_ngcontent-%COMP%], .theme-dark   [_nghost-%COMP%]   .counter__label[_ngcontent-%COMP%]{color:#96a8c0}.counter[_ngcontent-%COMP%]{display:block;width:100%;float:right;text-align:right}.counter--inline[_ngcontent-%COMP%]{display:inline-block;width:auto}"];
export { styles as styles };
